import { apiEndPoints, http } from "../../utils/http";

const getOccupation = (languageId) => {
  return http.get(`${apiEndPoints.GET_OCCUPATION}/${languageId}`);
};

const getBoard = (languageId) => {
  return http.get(`${apiEndPoints.GET_BOARD}/${languageId}`);
};

const getSchoolType = (languageId) => {
  return http.get(`${apiEndPoints.GET_SCHOOL_TYPE}/${languageId}`);
};

const getNewSchoolType = (stateId,languageId) => {
  return http.get(`${apiEndPoints.GET_NEW_SCHOOL_TYPE}/${languageId}/${stateId}`);
};

const getEducationStatus = (languageId) => {
  return http.get(`${apiEndPoints.GET_EDUCATIONALSTATUS}/${languageId}`);
};

const screening = {
  getOccupation,
  getSchoolType,
  getNewSchoolType,
  getBoard,
  getEducationStatus,
};
export default screening;
